import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { AssetsProvider } from "./Context/AssetsContext";
import { PWAProvider } from "./Context/PWAContext";
import * as serviceWorkerRegistration from "./serviceWorkerRegistration";

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <AssetsProvider>
      <PWAProvider>
        <App />
      </PWAProvider>
    </AssetsProvider>
  </React.StrictMode>
);

// Register service worker for caching and offline PWA capability
serviceWorkerRegistration.register({
  onUpdate: (registration) => {
    const waitingWorker = registration.waiting;
    if (waitingWorker) {
      waitingWorker.postMessage({ type: "SKIP_WAITING" });
    }
    // Show toast message notifying user of update and reload
    import("react-toastify").then(({ toast }) => {
      toast.info(
        "A new update of VheecO is available. Reloading to apply...",
        {
          position: "top-center",
          autoClose: 3000,
          onClose: () => window.location.reload()
        }
      );
    });
  }
});

reportWebVitals();

